import React, { useEffect, useState } from 'react';
import moment from 'moment';
import 'moment/locale/cs';
import './Calendar.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesLeft, faAnglesRight, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import ModalCreateEventForm from './ModalCreateEventForm'
import fetchData from '../../../function/fetchData';
import { FaMoneyBill1Wave } from 'react-icons/fa6';
import { faRotate, faMoneyBill, faBuildingColumns, faBackward } from '@fortawesome/free-solid-svg-icons';

moment.updateLocale('cs', {
    week: {
        dow: 1 // Den týdne, kdy začíná týden. 1 = Pondělí
    }
});
moment.locale('cs'); // Nastavení lokalizace na češtinu





const WeekCalendar = ({date, dataFromServer, setDate, fetchDataFromServer, token, server}) => {

    const [currentWeek, setCurrentWeek] = useState(moment().startOf('week'));
    const [showModalCreateEventFrom, setShowModalCreateEventFrom ] = useState(false)
    const [selectedOne, setSelectedOne ] = useState(null)

    const createEvent = (one, i) => {
        setSelectedOne({date: one, dayOfWeek: i + 1})
        setShowModalCreateEventFrom(true)
    }
    
    const extractTime = (datetime) => {
        return datetime.split(' ')[1];
    };

    const formatTime = (time) => {
        const extractTimeResult = extractTime(time)
        const result = extractTimeResult.split(':')
        return result[0] + ':' + result[1]
      };



    // Získá vše z kalendáře na určitý den
    const getCalendarsEventForDay = (date) => {
        const filteredEvents = dataFromServer?.calendar.filter(event => {
            // Získáme datum z události
            const eventDate = event.date.split(' ')[0]; // Rozdělíme datum a čas a vezmeme jen datum
    
            // Porovnáme datum z události s hledaným datem
            return eventDate === date;
        });
        return filteredEvents
    }


    // Získá vše z kalendáře na určitý den
    const getScheduleForDay = (date) => {
        const filteredEvents = dataFromServer?.schedule.filter(event => {
            // Získáme datum z události
            const eventDate = event.start.split(' ')[0]; // Rozdělíme datum a čas a vezmeme jen datum
    
            // Porovnáme datum z události s hledaným datem
            return eventDate === date;
        });
        return filteredEvents
    }


      const extractDate = (datetime) => {
        return datetime.split(' ')[0];
      };


    const nextWeek = () => {
        const newWeek = moment(currentWeek).add(1, 'weeks');
        setCurrentWeek(newWeek);
        setDate(newWeek.format('YYYY-MM-DD'))
    };

    const prevWeek = () => {
        const newWeek = moment(currentWeek).subtract(1, 'weeks'); // Vytvoření nového objektu moment pro předchozí týden
        setCurrentWeek(newWeek); // Aktualizace stavu aktuálního týdne
        setDate(newWeek.format('YYYY-MM-DD'))
    };


    const onDeleteEvent = ( id ) => {
        const whatToSend = {
            action: 'DELETE_EVENT' ,
            id: parseInt(id),
            driverToken: token
        }

        fetchData(server + 'api2/calendarController.php' , whatToSend)
        .then( (res) => {
            if(res.status === "OK"){
                fetchDataFromServer()
                setShowModalCreateEventFrom(false)
            } else {
                alert('Nastala chyba, zkuste to prosím později.')
            
            }
        })
    }

    const onDeleteSchedule = ( id ) => {
        const whatToSend = {
            action: 'DELETE_SCHEDULE' ,
            id: parseInt(id),
            driverToken: token
        }

        fetchData(server + 'api2/scheduleController.php' , whatToSend)
        .then( (res) => {
            if(res.status === "OK"){
                fetchDataFromServer()
                setShowModalCreateEventFrom(false)
            } else {
                alert('Nastala chyba, zkuste to prosím později.')
            
            }
        })
    }

    // Delete one
    const handleDelete = (type ,id ) => {
        const confirmDeletion = window.confirm("Opravdu chcete smazat tuto událost?");
        if (confirmDeletion) {
            if(type === 'calendar'){
                onDeleteEvent(id)
            } else if(type === 'schedule'){
                onDeleteSchedule(id)
            }
        }
    };

    const renderDays = () => {
        const today = moment();
        const days = [];
    
        for (let i = 0; i < 7; i++) {
            const day = currentWeek.clone().add(i, 'days');
            const calendarForActualDate = getCalendarsEventForDay( day.format('YYYY-MM-DD') ) ?? []
            const scheduleOfferForActualDate = getScheduleForDay( day.format('YYYY-MM-DD') ) ?? []
            const isCurrentDay = day.isSame(today, 'day');

            days.push(
                <div key={day.format('YYYY-MM-DD')} className={`day-column ${isCurrentDay ? 'current-day' : ''}`}>
                    <p className='oneDay'>
                        {day.format('dddd, DD MMM')}
                    </p>

                    <div className='addToCalendar' onClick={()=> createEvent(day, i)}>
                        <FontAwesomeIcon icon={faPlus} />
                        <p>Přidat</p>
                    </div>
                    
                    <div className='sectionCalendar'>
                        {
                            calendarForActualDate.map( (oneCalendar) => {
                                return <div key={oneCalendar.id} className='oneRowCalendar'>
                                            <p >{oneCalendar.nick}: {oneCalendar.text}</p>
                                         
                                            <FontAwesomeIcon icon={faTrash} color='white' onClick={()=> handleDelete('calendar', oneCalendar.id)}/>
                                        </div>
                                
                            })
                        }
                    </div>

                    <div className='sectionScheduleJob'>
                        {
                            scheduleOfferForActualDate.map( (oneCalendar) => {
                        
                                return  <div key={oneCalendar.id} className='oneRowScheduleOffer' style={parseInt(oneCalendar.change_request) === 1 ? {background: 'red'}:{background: '#038C8C'}}>
                                                <div>
                                                    <p style={{color: 'white', fontWeight: 'bold', fontSize: 18}}>{oneCalendar.nick}</p>
                                                    <p style={{color: 'white'}}>{formatTime(oneCalendar.start)}-{formatTime(oneCalendar.end)}</p>  
                                            
                                                    {parseInt(oneCalendar.change_request) === 1 && <p style={{color: 'white', marginTop: 5}}>Žádost o výměnu</p>}
                                                </div>
                                                <div style={{display: 'flex',gap: 10, alignItems: 'center'}}>
                                                    {oneCalendar.payedBy === 'cache' &&  <FaMoneyBill1Wave  color={'white'}/> }
                                                    {oneCalendar.payedBy === 'bank' &&  <FontAwesomeIcon icon={faBuildingColumns}  color={'white'}/> }
                                                    <FontAwesomeIcon icon={faTrash} color='white' onClick={()=> handleDelete('schedule', oneCalendar.id)} />
                                                </div>
                                        </div>
                            })
                        }
                    </div>

                </div>
            );
        }
        return days;
    };

    return (
        <div className="week-calendar">
            <ModalCreateEventForm 
                showModalCreateEventFrom={showModalCreateEventFrom}
                setShowModalCreateEventFrom={setShowModalCreateEventFrom}
                selectedOne={selectedOne}
                dataFromServer={dataFromServer}
                fetchDataFromServer={fetchDataFromServer}
                token={token}
                server={server}
            />
            <div className="controls">
                <button onClick={prevWeek} className='arrowBtn'>
                    <FontAwesomeIcon icon={faAnglesLeft} />
                </button>
                <button onClick={nextWeek} className='arrowBtn'>
                    <FontAwesomeIcon icon={faAnglesRight} />
                </button>

                    {currentWeek.format('MMMM YYYY')}
       
            </div>
            <div className="days">
                {renderDays()}
            </div>
        </div>
    );
};

export default WeekCalendar;
